import getEnvVar from '@utils/getEnvVar';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export default () => {
  if (getEnvVar('SENTRY_ENVIRONMENT') !== 'local') {
    Sentry.init({
      Vue,
      dsn: getEnvVar('SENTRY_DSN'),
      environment: getEnvVar('SENTRY_ENVIRONMENT'),
    });
  }
};
